import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Download, Printer } from "lucide-react";
import { http, formatApiError } from "../lib/api";

export const XaltixBrochure = () => {
  const [on, setOn] = useState(null);
  useEffect(() => { http.get("/xaltix/settings").then((r) => setOn(!!r.data.brochure_public)).catch(() => setOn(false)); }, []);
  const toggle = async () => {
    try { const r = await http.put("/xaltix/settings", { brochure_public: !on }); setOn(!!r.data.brochure_public); toast.success(!on ? "Plaquette visible sur la page XALTIX" : "Plaquette masquée de la page XALTIX"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const link = "inline-flex items-center gap-1.5 border border-slate-300 hover:bg-slate-50 px-3 py-2 rounded-md text-sm font-semibold";
  return (
    <div data-testid="xaltix-brochure" className="border border-slate-200 rounded-lg p-5 bg-white space-y-3">
      <div className="flex items-center gap-2"><BookOpen className="h-5 w-5 text-amber-600" /><h3 className="font-bold">Plaquette XALTIX (A5, 8 pages)</h3></div>
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-xs font-bold text-slate-500 w-10">FR</span>
        <a data-testid="xaltix-brochure-screen" href="/xaltix-plaquette.pdf?v=1" target="_blank" rel="noreferrer" className={link}><Download className="h-4 w-4" />Version écran</a>
        <a data-testid="xaltix-brochure-print" href="/xaltix-plaquette-imprimeur.pdf?v=1" download="XALTIX-plaquette-imprimeur.pdf" className={link}><Printer className="h-4 w-4" />Version imprimeur (fond perdu 3 mm, traits de coupe)</a>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-xs font-bold text-slate-500 w-10">EN</span>
        <a data-testid="xaltix-brochure-en-screen" href="/xaltix-brochure-en.pdf?v=1" target="_blank" rel="noreferrer" className={link}><Download className="h-4 w-4" />Screen version</a>
        <a data-testid="xaltix-brochure-en-print" href="/xaltix-brochure-en-print.pdf?v=1" download="XALTIX-brochure-EN-print.pdf" className={link}><Printer className="h-4 w-4" />Print version (3 mm bleed, crop marks)</a>
      </div>
      {on !== null && (
        <label className="flex items-center gap-2 text-sm font-semibold cursor-pointer">
          <input data-testid="xaltix-brochure-public-toggle" type="checkbox" checked={on} onChange={toggle} className="h-4 w-4" />
          Afficher le bouton « Télécharger la plaquette (FR / EN) » sur la page XALTIX
        </label>
      )}
    </div>
  );
};
